import React, { memo } from 'react';

import { AppBar, Toolbar, Container } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import IconButton from '~/components/IconButton';
import ScreenSizeDebugger from '~/components/ScreenSizeDebugger';
import { connectScreenSize } from '~/helpers/screen-size-helper';
import useClassNames from '~/hooks/use-classnames';
import { actions } from '~/redux/ducks';
import thunks from '~/redux/thunks';
import colors from '~/values/colors';

import styles from './AppHeaderBar.module.scss';

const AppHeaderBar = memo(({ isDesktop, toggleSidebar, sidebarCollapsed }) => {
    const appBarClasses = useClassNames([
        styles.appBar,
        { [styles.appBarOpened]: isDesktop && !sidebarCollapsed },
    ]);

    return (
        <AppBar position="static" className={appBarClasses}>
            <Container className={styles.headerContainer}>
                <Toolbar className={styles.header}>
                    <div className={styles.menuButton}>
                        <IconButton
                            icon="menu"
                            onClick={toggleSidebar}
                            color={colors.textOnAccent}
                            title={sidebarCollapsed ? 'Abrir menu' : 'Fechar menu'}
                        >
                            <MenuIcon />
                        </IconButton>
                    </div>
                    <div className={styles.imageContainer}>
                        <img
                            alt="DHO - Departamento Humano Organizacional"
                            src={require('~/assets/logo.svg').default}
                            className={styles.logotipo}
                        />
                    </div>

                    <ScreenSizeDebugger />
                </Toolbar>
            </Container>
        </AppBar>
    );
});

AppHeaderBar.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
    toggleSidebar: PropTypes.func.isRequired,
};

const mapStateToProps = ({ sidebarCollapsed, user }) => ({
    sidebarCollapsed,
    user,
});

const mapDispatchToProps = {
    toggleSidebar: actions.sidebar.toggleSidebar,
    removeAuthenticationData: thunks.user.removeAuthenticationData,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(connectScreenSize(withRouter(AppHeaderBar)));
